import type { StripeProducts } from '@racemap/sdk/schema/billing';
import type { EventUserCredit, UserCredit } from '@racemap/sdk/schema/userCredits';
import { castDraft, type Immutable } from 'immer';
import { groupBy } from '../utils';

export const getUserCreditsAccumulated = (
  userCredits: Immutable<Array<UserCredit | EventUserCredit>>,
  accumulateUsedQuantity = false,
): Map<StripeProducts, number> => {
  const creditsGrouped = groupBy(castDraft(userCredits), (credit) => credit.type);

  return Array.from(creditsGrouped.entries()).reduce((acc, [type, credits]) => {
    acc.set(
      type,
      credits.reduce(
        (sum, credit) =>
          sum +
          (accumulateUsedQuantity
            ? credit.charges.reduce((s, charge) => s + charge.usedQuantity, 0)
            : credit.quantity),
        0,
      ),
    );
    return acc;
  }, new Map<StripeProducts, number>());
};
